/**
 * Ads Admin IA Phase B — route／選單標題輔助（不硬編第二套 permission 樹）
 */
export const ADS_CANONICAL_REVIEW = '/system/ads/review';
export const ADS_CANONICAL_CAMPAIGNS = '/system/ads/campaigns';
export const ADS_ENTRY_PATH = '/system/ads';

export const ADS_LEGACY_REVIEW = '/system/travel-manage/ads-review';
export const ADS_LEGACY_CAMPAIGNS = '/system/travel-manage/ads-campaigns';

export const ADS_PAGE_PATHS = [
  ADS_CANONICAL_REVIEW,
  ADS_CANONICAL_CAMPAIGNS,
];

/** legacy → canonical（不含 query；呼叫端附加） */
export const ADS_LEGACY_TO_CANONICAL = {
  [ADS_LEGACY_REVIEW]: ADS_CANONICAL_REVIEW,
  [ADS_LEGACY_CAMPAIGNS]: ADS_CANONICAL_CAMPAIGNS,
};

export const ADS_ROUTE_TITLES = {
  [ADS_CANONICAL_REVIEW]: '廣告審核',
  [ADS_CANONICAL_CAMPAIGNS]: '廣告活動營運',
  [ADS_ENTRY_PATH]: '廣告管理',
  [ADS_LEGACY_REVIEW]: '廣告審核',
  [ADS_LEGACY_CAMPAIGNS]: '廣告活動營運',
};

/**
 * 自登入 permission 樹找出具 path 的節點（依 name；支援一層孫節點）。
 */
export function findPermissionPathByName(permissions, permissionName) {
  if (!Array.isArray(permissions) || !permissionName) {
    return null;
  }
  for (const mod of permissions) {
    if (mod?.name === permissionName && mod.path) {
      return mod.path;
    }
    for (const child of mod?.subMenu || []) {
      if (child?.name === permissionName && child.path) {
        return child.path;
      }
      for (const grand of child?.subMenu || []) {
        if (grand?.name === permissionName && grand.path) {
          return grand.path;
        }
      }
    }
  }
  return null;
}

function hasNavigablePath(permissions, path) {
  if (!Array.isArray(permissions) || !path) {
    return false;
  }
  for (const mod of permissions) {
    if (mod?.path === path) {
      return true;
    }
    for (const child of mod?.subMenu || []) {
      if (child?.path === path) {
        return true;
      }
    }
  }
  return false;
}

/**
 * /system/ads 入口：導向第一個有權限的 Ads 子頁。
 * Both → Review；Review-only → Review；Campaign-only → Campaigns；None → null。
 */
export function resolveAdsEntryPath(permissions) {
  const hasReview =
    Boolean(findPermissionPathByName(permissions, 'travel:ads:review'))
    || hasNavigablePath(permissions, ADS_CANONICAL_REVIEW);
  const hasCampaigns =
    Boolean(findPermissionPathByName(permissions, 'travel:ads:campaign-ops'))
    || hasNavigablePath(permissions, ADS_CANONICAL_CAMPAIGNS);

  if (hasReview) {
    return ADS_CANONICAL_REVIEW;
  }
  if (hasCampaigns) {
    return ADS_CANONICAL_CAMPAIGNS;
  }
  return null;
}

export function buildLegacyRedirectTarget(legacyPath, search = '', hash = '') {
  const canonical = ADS_LEGACY_TO_CANONICAL[legacyPath];
  if (!canonical) {
    return null;
  }
  return `${canonical}${search || ''}${hash || ''}`;
}
